import _default from './Button';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Button/index.js
// module id = 435
// module chunks = 1